import bodybuilder from 'bodybuilder'
import * as Form from '../../../components/form'
import * as Elasticsearch from '../../../elasticsearch'
import * as Request from '../../../request'
import * as ReportUtils from '../utils'
import * as Constants from './constants'
import * as Types from './types'

export const fetchTopArticleDetails = (community: string, topArticles: Types.State) =>
Request.requestActionCreator(Constants.FETCH_TOP_ARTICLE_DETAILS)
({
  method: 'POST',
  payload: {
    postIds: topArticles.data.map((a: Types.TopArticle) => a.postId),
  },
  url: `${Constants.POSTS_SERVER_RESOURCE}/${community}/topArticleDetails`,
})

export const fetchTopArticleSendFunction = (event: string, isPromotion: boolean) =>
  (community: string, topArticles: Types.State) =>
  Elasticsearch.createEsSearch(event)(
    community,
    Elasticsearch.Indexes.TopClicks.MessageRunDetails,
    bodybuilder().size(0)
    .filter(
      'term',
      Elasticsearch.keyword(Elasticsearch.DocumentFieldNames.Community),
      community)
    .query(
      'range',
      Elasticsearch.DocumentFieldNames.MessageSendDate,
      ReportUtils.searchDateRange(topArticles.form))
    .query(
      'terms',
      isPromotion ?
        Elasticsearch.DocumentFieldNames.CommunityPromotionId :
        Elasticsearch.DocumentFieldNames.PostId,
      topArticles.data.map((a: Types.TopArticle) => a.postId))
    .aggregation(
      'terms',
      isPromotion ?
        Elasticsearch.DocumentFieldNames.CommunityPromotionId :
        Elasticsearch.DocumentFieldNames.PostId,
      {
        size: topArticles.data.length,
      },
      Elasticsearch.DocumentFieldNames.PostId,
      (uniquePosts: any) => uniquePosts.aggregation(
        'cardinality',
        Elasticsearch.DocumentFieldNames.CommunityPersonId,
        Elasticsearch.AggFieldNames.UniqueCount))
    .build(),
  )

export const fetchTopArticlesFunction = (event: string, isPromotion: boolean, max: number) =>
  (community: string, form: Types.FormState) => {
  // Get a query object ready
  const esQuery: any = bodybuilder().size(0)

  // First, the filtering
  const filteredQuery: any = esQuery.filter(
      'term',
      Elasticsearch.keyword(Elasticsearch.DocumentFieldNames.EventName),
      'click')
    .filter(
      'term',
      Elasticsearch.keyword(Elasticsearch.DocumentFieldNames.Community),
      community)
    .filter(
      'term',
      Elasticsearch.DocumentFieldNames.IncludeInReports,
      true)
    .filter(
      'exists',
      isPromotion ?
        Elasticsearch.DocumentFieldNames.CommunityPromotionId :
        Elasticsearch.DocumentFieldNames.PostSubscriptionId)
    .query(
      'range',
      Elasticsearch.DocumentFieldNames.MessageSendDate,
      ReportUtils.searchDateRange(form))

    // Add the aggregations
  const aggregatedQuery = filteredQuery.aggregation(
      'terms',
      isPromotion ?
        Elasticsearch.DocumentFieldNames.CommunityPromotionId :
        Elasticsearch.DocumentFieldNames.PostId,
      {
        size: max,
      },
      Elasticsearch.DocumentFieldNames.PostId,
      (uniquePosts: any) => uniquePosts.aggregation(
        'cardinality',
        Elasticsearch.keyword(Elasticsearch.DocumentFieldNames.CommunityPersonGuid),
        Elasticsearch.AggFieldNames.UniqueCount,
        {
          precision_threshold: 40000,
        },
      ).aggregation(
        'terms',
        Elasticsearch.keyword(form.fields.sourceType),
        Elasticsearch.DocumentFieldNames.SourceName,
      ).aggregation(
        'terms',
        Elasticsearch.DocumentFieldNames.IssueId,
        Elasticsearch.DocumentFieldNames.IssueId,
      ).aggregation(
        'terms',
        Elasticsearch.DocumentFieldNames.SuspectClick,
        Elasticsearch.DocumentFieldNames.SuspectClick,
        (uniquePostTypes: any) => uniquePostTypes.aggregation(
          'cardinality',
          Elasticsearch.keyword(Elasticsearch.DocumentFieldNames.CommunityPersonGuid),
          Elasticsearch.AggFieldNames.UniqueCount,
          {
            precision_threshold: 40000,
          },
        ),
      ).aggregation(
        'terms',
        Elasticsearch.keyword(Elasticsearch.DocumentFieldNames.PostType),
        Elasticsearch.DocumentFieldNames.PostType,
        (uniquePostTypes: any) => uniquePostTypes.aggregation(
          'cardinality',
          Elasticsearch.keyword(Elasticsearch.DocumentFieldNames.CommunityPersonGuid),
          Elasticsearch.AggFieldNames.UniqueCount,
        ),
      ),
    )

  return Elasticsearch.createEsSearch(event)(
    community,
    Elasticsearch.Indexes.TopClicks.EmailActions,
    aggregatedQuery.build())
}

export const fetchTopArticles =
  fetchTopArticlesFunction(Constants.FETCH_TOP_ARTICLES, false, Constants.NUM_TOP_ARTICLES)
export const fetchTopArticleSends =
  fetchTopArticleSendFunction(Constants.FETCH_TOP_ARTICLE_SENDS, false)

export const FormActions = Form.createActionsMap(Constants.TOP_ARTICLES_FILTER)



// WEBPACK FOOTER //
// ./src/pages/reports/top-articles/actions.ts